export default __webpack_public_path__ + "static/media/background-birth-plan.6feafa6a.jpg";